// extracted by mini-css-extract-plugin
export var downloadLinks = "downloads-module--downloadLinks--GKWbV";
export var downloads = "downloads-module--downloads--Fanxb";